import {Component, inject, Input, OnInit} from '@angular/core';
import {AppointmentSelectionService} from '../../appointment-selection.service';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {DatePipe, Location} from '@angular/common';
import {TimeSlotModel} from '../../models/time-slot.model';
import {DateTime} from 'luxon';
import {Router} from '@angular/router';
import {TranslocoPipe} from '@jsverse/transloco';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {WindowReferenceService} from '../../../../core/services/window.service';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

@Component({
  selector: 'app-time-selection',
  imports: [
    IconButtonComponent,
    TranslocoPipe,
    TextButton,
    CustomDatePipe
  ],
  templateUrl: './time-selection.component.html',
  styleUrl: './time-selection.component.scss'
})
export class TimeSelectionComponent implements OnInit {
  @Input() mobile = true;

  location: Location = inject(Location);
  router: Router = inject(Router);
  appointmentSelectionService: AppointmentSelectionService = inject(AppointmentSelectionService);
  windowSerivce = inject(WindowReferenceService);

  get day(): string {
    return this.appointmentSelectionService.dateForm?.value?.toFormat('dd.MM.yyyy');
  }

  ngOnInit() {
    if (!this.appointmentSelectionService.timeSlotModels || this.appointmentSelectionService.timeSlotModels.length === 0) {
      this.router.navigate(['/appointment-selection']);
    }
  }

  back() {
    this.location.back();
  }

  isSelected(timeSlotModel: TimeSlotModel): boolean {
    const selectedTimeSlotModel: TimeSlotModel = this.appointmentSelectionService.timeSlotForm?.value;
    return selectedTimeSlotModel?.startTime === timeSlotModel.startTime && selectedTimeSlotModel?.endTime === timeSlotModel.endTime;
  }

  selectTimeSlot(timeSlotModel: TimeSlotModel) {
    this.appointmentSelectionService.timeSlotForm?.setValue(timeSlotModel);

    const isoDate = this.appointmentSelectionService.dateForm?.value?.toISODate();
    let timeSlotDtos = this.appointmentSelectionService.timeSlotDtosMap?.get(isoDate);

    timeSlotDtos = timeSlotDtos?.filter(t => t.startTime == timeSlotModel.startTime && t.endTime == timeSlotModel.endTime);
    this.appointmentSelectionService.timeSlotDto = timeSlotDtos?.[0];
    if (this.windowSerivce.pushEvents) {
      var payload = {
        event: 'date_selection',
        selectedDate: DateTime.fromISO(timeSlotModel.startTime).setZone('Europe/Zurich').toFormat('yyyy-MM-dd'),
        time: `${DateTime.fromISO(timeSlotModel.startTime).setZone('Europe/Zurich').toFormat('HH:mm')} - ${DateTime.fromISO(timeSlotModel.endTime).setZone('Europe/Zurich').toFormat('HH:mm')}`
      };
      this.windowSerivce.push(payload);
    }

    this.router.navigate(['/booking']);
  }
}
